import React from 'react';

export default function FileInput({
  label,
  fileType = 'image',
  id,
  onChange = () => {},
  capture = '',
}) {
  return (
    <div>
      <input
        id={id}
        type="file"
        accept={`${fileType}/*`}
        onChange={onChange}
        className="hidden"
        {...(capture.length && { capture })}
      />
      <label
        htmlFor={id}
        className="flex items-center justify-center bg-button text-white cursor-pointer px-4 py-3 rounded-lg w-[180px] uppercase hover:bg-black transition duration-300"
      >
        {label}
      </label>
    </div>
  );
}
